import { render, staticRenderFns } from "./PostersNav.vue?vue&type=template&id=14f5d154&scoped=true&"
import script from "./PostersNav.vue?vue&type=script&lang=js&"
export * from "./PostersNav.vue?vue&type=script&lang=js&"
import style0 from "./PostersNav.vue?vue&type=style&index=0&id=14f5d154&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f5d154",
  null
  
)

export default component.exports